/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";

export default function useLeftMenuOptions() {
  const getOffset = (id) => {
    const ele = document.getElementById(id);
    const subele = document.getElementById(`${id}Sub`);
    const subMenuHeight = subele.scrollHeight;

    if (ele && subMenuHeight) {
      const offsetTop = ele.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      if (windowHeight > offsetTop + subMenuHeight) {
        return offsetTop;
      }
      return offsetTop - (offsetTop + subMenuHeight - windowHeight) - 10;
    }
    return null;
  };

  const setSubMenuPosition = () => {
    const arr = [
      "userLeftMenu",
      "communityLeftMenu",
      "toolboxLeftMenu",
      "supportMenu",
      "libraryMenu",
      "marketPlaceMenu",
      "notificationMenu",
      "dashboardMenu",
      "myPatientMenu",
      "inviteFriendMenu",
    ];
    arr.forEach((element) => {
      const eleUser = document.getElementById(`${element}Sub`);
      if (eleUser?.style) {
        eleUser.style.top = `${getOffset(element)}px`;
      }
    });
  };

  useEffect(() => {
    setSubMenuPosition();
    const ele = document.getElementById("leftMenuMain");
    ele?.addEventListener("scroll", setSubMenuPosition);
    ele?.addEventListener("mouseenter", setSubMenuPosition);
    ele?.addEventListener("mouseover", setSubMenuPosition);
  }, []);
  return null;
}
